// test2684
(2684 && 0);
